import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VAutocomplete,_vm._b({attrs:{"label":_vm.$t('Delivery time'),"items":_vm.times,"clearable":"","outlined":"","prepend-icon":"schedule","hide-details":"auto"},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}},'v-autocomplete',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }